import { Routes, Route, Navigate } from 'react-router-dom'  // Changed Switch to Routes
import ProposalSendSuccessView from 'proposals/proposal/views/ProposalSendSuccessView'
import NotFoundView from 'proposals/notFound/views/NotFoundView'
import ErrorView from 'app/error/views/ErrorView'
import PrivacyPolicy from 'proposals/privacyPolicy/views/PrivacyPolicy'
import { useAuth0 } from '@auth0/auth0-react'
import PrivateRoute from 'auth/PrivateRoute'
import Vendors from 'vendors/Vendors'
import { VendorsFetchProvider } from 'vendors/api/VendorsFetchContext'
import VendorLogin from 'vendors/VendorLogin'
import ProposalEditView from 'proposals/edit/ProposalEditView'
import ProposeView from 'proposals/proposal/views/ProposeView'
import ProposalEditSuccessView from 'proposals/edit/ProposalEditSuccessView'
import PublicRequestForProposalView from 'proposals/proposal/views/PublicRequestForProposalView'
import ProposalReadOnlyView from 'proposals/readOnly/ProposalReadOnlyView'

const AppRoutes = () => { 
  const { isLoading } = useAuth0()

  if (isLoading) {
    return null
  }

  return (
    <VendorsFetchProvider>
      <Routes>  {/* Changed from Switch */}
        <Route path="/" element={<Navigate to="/vendors/login" replace />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/error" element={<ErrorView />} />
        <Route path="/vendors/login" element={<VendorLogin />} />
        <Route path="/vendors/*" element={<PrivateRoute component={Vendors} />} />
        <Route path="/:token" element={<ProposeView />} />
        <Route path="/:token/success" element={<ProposalSendSuccessView />} />
        <Route path="/:proposalId/edit" element={<PrivateRoute component={ProposalEditView} />} />
        <Route path="/:proposalId/edit/success" element={<PrivateRoute component={ProposalEditSuccessView} />} />
        <Route path="/:proposalId/view" element={<PrivateRoute component={ProposalReadOnlyView} />} />
        <Route path="/public/:uniqueToken" element={<PublicRequestForProposalView />} />
        <Route path="/not-found" element={<NotFoundView />} />  {/* Catch-all route */}
      </Routes>
    </VendorsFetchProvider>
  )
}

export default AppRoutes
